import React, { Component } from 'react';
import i18n from 'kodyl-js/i18n/react';
import Dwelling, { Lazy as LazyDwelling } from './dwellings-single';
import LoadingSpinner from '../common/loading-spinner';
import { withRouter } from 'react-router';
import qs from 'qs';
const DEFAULT_JUMP_AMOUNT = 150;

@i18n
class DwellingsList extends Component {
  constructor(props) {
    super(props);

    const init = qs.parse(props.location.search, { ignoreQueryPrefix: true });
    this.state = {
      start: init.start || 0,
      initQuery: init,
      jump: props.paginationJump || DEFAULT_JUMP_AMOUNT
    };
  }

  previousPage = () => {
    this.setState(state => {
      const jump = state.start - state.jump;
      this.props.router.push(
        `${this.props.location.pathname}?${
          jump <= 0
            ? qs.stringify(state.initQuery)
            : qs.stringify({ ...state.initQuery, start: jump })
        }`
      );
      return { start: jump };
    });
  };
  nextPage = () => {
    this.setState(state => {
      const jump = state.start + state.jump;
      this.props.router.push(
        `${this.props.location.pathname}?${qs.stringify({
          ...state.initQuery,
          start: jump > this.props.totalResults ? this.props.totalResults : jump
        })}`
      );
      return { start: jump };
    });
  };

  render() {
    const {
      frontpage,
      data,
      firstView,
      headline,
      loading,
      totalResults
    } = this.props;
    const Single = firstView ? Dwelling : LazyDwelling;

    const hasPreviousPage = this.state.start > 0;
    const hasNextPage = this.state.start < totalResults;

    return data.length || loading ? (
      <div>
        <div className="listings-heading">
          <h3>{loading ? this.i18n('Loading dwellings...') : headline}</h3>
        </div>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <>
            <ul className="search-results">
              {data.map(dwelling => {
                const id = dwelling.dwellingId;
                const link = `/vis/${id}`;

                const props = {
                  id,
                  key: id,
                  dwelling,
                  link
                };

                return <Single {...props} />;
              })}
            </ul>
            {!frontpage && (
              <div
                style={{
                  marginTop: '20px',
                  display: 'flex',
                  justifyContent: 'space-between'
                }}
              >
                {hasPreviousPage ? (
                  <button className="btn hidden-xs" onClick={this.previousPage}>
                    <i className="fa fa-angle-left fa-fw" />
                    {this.i18n('forrige')}
                  </button>
                ) : (
                  <span>&nbsp;</span>
                )}
                {hasNextPage && (
                  <button className="btn hidden-xs" onClick={this.nextPage}>
                    {this.i18n('næste')}{' '}
                    <i className="fa fa-angle-right fa-fw" />
                  </button>
                )}
              </div>
            )}
          </>
        )}
      </div>
    ) : (
      <div>
        <h3>{this.i18n('Sorry!')}</h3>
        <h4>
          {this.i18n(
            'Der findes desværre ingen lejemål, som matcher dine ønsker. Prøv at udvide din boligsøgning.'
          )}
        </h4>
      </div>
    );
  }
}

export default withRouter(DwellingsList);
